import { FileUploadLite } from "@/Common/Components/FileUpload/FileUploadLite";
import { Popup } from "@/Common/Components/Modals/Popup";
import { ProfilePicture as MyleModelsCommonProfilePicture } from "@/Common/Models/UI/ProfilePicture";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

import img_p_banner_icon_100 from "@/Globals/_images/p-banner-icon-100.png";

interface IPatientProfileImagePopupProps {
    profilePictureModel: MyleModelsCommonProfilePicture;
    localDispatchContext: any;
    beginUpload?: boolean;
    cancelOperation?: number;
    cancelCallbackFunction?: () => any;
    uploadCompleteOperation?: number;
    uploadCompleteCallbackFunction?: (path: string) => void;
    deletePicOperation?: number;
}

class PatientProfileImageState {
    public FileList: any;
}

class PatientProfileImagePopup extends React.Component<IPatientProfileImagePopupProps, PatientProfileImageState> {
    public constructor(props: IPatientProfileImagePopupProps) {
        super(props);

        this.state = {
            FileList: null
        };
    }

    public render(): JSX.Element {
        const imageUrl = this.props.profilePictureModel
            ? apiSettings.buildAppUrl(`api/patient/profile/image/fetch/${this.props.profilePictureModel.Id}`, { auth: true, noCache: true })
            : img_p_banner_icon_100;

        return (
            <Popup
                cssClass="profileimage"
                draggable
                manageOverlay
                title={cacheStore.GetString("ChangePictureLabel")}
                closeTarget={this.props.cancelOperation}
                onCloseDelegate={this.props.cancelCallbackFunction}
            >
                <div className="p-body">
                    <div className="row no-side-margin">
                        <div className="col-lg-12">
                            <div>
                                <img src={imageUrl} style={{ width: "512px" }} />
                            </div>
                            <div style={{ float: "left" }}>
                                <FileUploadLite
                                    onCompleteOperation={this.props.uploadCompleteOperation}
                                    onCompleteCallback={path => this.props.uploadCompleteCallbackFunction?.(path)}
                                    fileDestinationPath={3}
                                />
                            </div>
                            {this.props.profilePictureModel != null && this.props.profilePictureModel != undefined && this.props.deletePicOperation && (
                                <div style={{ float: "right", marginRight: "30px" }}>
                                    <a onClick={() => this.deleteProfilePic(this.props.profilePictureModel)}>{cacheStore.GetString("RemoveLabel")}</a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="p-footer">
                    <div className="row no-side-margin">
                        <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                            <div>
                                <button data-action="save" className="btn btn-default push-right-5" onClick={this.CancelClick.bind(this)}>{cacheStore.GetString("CancelLabel")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }

    private CancelClick(): void {
        if (this.props.cancelOperation != null) {
            var operation = new LocalEvent(this.props.cancelOperation);
            LocalEventDispatcher.dispatch(operation);
        }

        this.props.cancelCallbackFunction && this.props.cancelCallbackFunction();
    }

    private deleteProfilePic(ProfilePicture: MyleModelsCommonProfilePicture): void {
        sessionStore.showPopup({
            title: cacheStore.GetString("RemoveLabel"),
            content: cacheStore.GetString("DeleteMedicalItem3Label"),
            showCancel: true,

            okAction: () => {
                sessionStore.dispatch(this.props.deletePicOperation, { ProfilePicture: ProfilePicture });
                this.props.cancelCallbackFunction && this.props.cancelCallbackFunction();
            }
        });
    }
}

export { PatientProfileImagePopup };
